/**
 * Konfiguracja aplikacji
 * Centralne miejsce do zarządzania ścieżkami i adresami URL
 */

export class Config {
    // Główny adres API, używany do komunikacji z backendem
    static readonly API_URL = `${window.location.origin}/api`;

    // Ścieżki do zasobów
    static readonly ASSETS_PATH = '/images/';
    static readonly NEWS_ASSETS_PATH = '/images/news/';
    static readonly GALLERY_PHOTOS_PATH = '/images/Gallery/photos/';
    static readonly GALLERY_CERTS_PATH = '/images/Gallery/certs/';
    static readonly ICONS_PATH = '/icons/';
    static readonly SOCIAL_ICONS_PATH = '/social-icons/';

    // Bazowy URL strony (używany w metatagach i generowaniu linków)
    static readonly BASE_URL = 'https://podatki-saldo.pl';
}

export default Config;
